module.exports = {
    亚马逊: '亚马逊礼品卡',
    沃尔玛: '沃尔玛礼品卡',
    星巴克: '星巴克礼品卡',
    苹果卡: '苹果礼品卡',
    PayPal: 'PayPal 转账',
    综合评价: '综合评价',
    // 选择语言
    popupTitle: '选择语言',
    // 发送
    send: '确认',
    // 发送邮件
    sendEmail: '发送邮件',
    // 改变语言
    changeLanSes: '语言切换成功',

    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',

    // 系统标题
    title: '买家之声',
    // 系统解释
    details: '倾听买家心声，提供优质产品和服务，感谢分享。',
    // input
    input: '请输入',

    sys: {
        // 明信片code码
        sendCode: `你好，
    感谢您的参与。
    请输入明信片上印有的蓝色唯一代码。`,
        // 明信片code码文本框提示
        codePlaceholder: '请输入您的代码！（例如：1234）',
        // 验证中
        verifying: '正在验证...',
        // 邮件提示
        email: '请输入您的邮箱地址以接收礼物。',
        // 邮件文本输入提示
        emailPlaceholder: '请输入您的邮箱！',
        // 邮件验证失败提示
        emailVerification: '邮箱验证失败！',
        // 确认邮件提示
        comfirmEmail: '请确认您将接收礼物的邮箱地址。',
        // 产品 文本信息
        productInfo: `以下是您在我们商店购买的商品信息：`,
        // 产品 图片
        productInfoPic: '<strong>{param}</strong>',
        // 打星文本提示
        starMsg: `您对这款产品或我们的服务满意吗？
    请为下面的产品打星评分：`,
        // 选择渠道提示 
        lowChannelSelect: '',
        channelSelect: '感谢您的参与，请选择您希望收到礼物的形式。',
        // 文字评价提示
        textRateQuestion: '<strong>添加文字评价</strong><br/>您喜欢什么？您是如何使用这个产品的？',
        // 用户评价后 展出用户评价内容提示
        formImgDetails: '您的评价详情：',
        // 引导用户 跳转到亚马逊 进行订单评价提示
        jumpAmazon: '购物体验对其他顾客尤为重要，如果您愿意在亚马逊上与其他顾客分享，可以获得额外奖励。<br/>请前往亚马逊订单页面，评价产品并上传截图。',
        // paypal 礼品卡类型时 提示
        extraInfo: '请输入您的 PayPal 账户！',
        // 订单号 提示
        orderNo: '请输入您的订单号！',
        // 最后结束语
        finally: '感谢您！您的礼物将在 72 小时内通过 redeem@amazonsurveyzone.com 发送到您的邮箱，请注意查收。',

        // 暂时没用上的
        previewPic: '预览提交信息图片',
        lowText: '感谢您的参与，请选择直接领取礼品卡或跳转到邮箱页面。',
    },
    client: {
        saveCode: '您的唯一代码：<strong>{param}</strong>'
    },
    pic: {
        // 用户评价后 form详情 标题
        title: '表单详情',
        // 用户评价后 form详情的明信片码
        code: '您的唯一代码：',
        // 用户评价后 form详情的邮件
        email: '邮箱：',
        // 用户评价后 form详情的文本评价
        written: '我的评价',
        // 用户评价后 form详情的产品图片文本
        picLabel: '猫咪图片：',
    }
}
